import { Link as RouterLink, useLocation } from "react-router-dom";
// hooks
import useLocales from "../../hooks/useLocales";
// constants
import { APP_ROUTES_V2 } from "../../common/V2/constants";
// utils
import { capitalEvery } from "../../utils/textEnhancers";

const NavigationMenuV2 = () => {
  const { translate } = useLocales();
  const { pathname } = useLocation();

  if (pathname.includes(APP_ROUTES_V2.CUSTOMERS)) {
    return null;
  }

  return (
    <ui-nav-menu>
      {/* DASHBOARD */}
      <RouterLink to={APP_ROUTES_V2.DASHBOARD} rel="home" active={{ value: pathname === APP_ROUTES_V2.DASHBOARD }} />
      {/*  */}

      {/* CUSTOMER EXPERIENCES */}
      <RouterLink to={APP_ROUTES_V2.CUSTOMER_EXPERIENCES.ROOT}>
        {capitalEvery(translate("nav.customer-experiences"))}
      </RouterLink>

      {/* ADD PRODUCTS */}
      <RouterLink to={APP_ROUTES_V2.PRODUCTS.ROOT}>{capitalEvery(translate("nav.products"))}</RouterLink>
      {/*  */}

      {/* NOTIFICATIONS */}
      <RouterLink to={APP_ROUTES_V2.NOTIFICATIONS.ROOT}>{capitalEvery(translate("nav.notifications"))}</RouterLink>
      {/*  */}

      {/* REPORTS */}
      <RouterLink to={APP_ROUTES_V2.REPORTS.ROOT}>{capitalEvery(translate("nav.reports"))}</RouterLink>

      {/* ACCOUNT */}
      <RouterLink to={APP_ROUTES_V2.ACCOUNT}>{capitalEvery(translate("nav.account-v2"))}</RouterLink>
      {/*  */}
    </ui-nav-menu>
  );
};

export default NavigationMenuV2;
